/**
 * Whether a Radix layer that owns the keyboard is on screen — a dialog or
 * sheet, and equally a menu, select, popover or tooltip.
 *
 * Screen-level keys that leave the current surface (Escape-to-back, `u`) check
 * this and stand down. Each layer registers its own dismiss handler on open,
 * after the screen-level one, so navigating here would yank the user out from
 * behind a surface they were only trying to close — or, for a key the layer
 * treats as typeahead, out from under one they were typing into.
 *
 * A DOM query rather than the event's `defaultPrevented`, which is what Radix
 * actually sets when a layer consumes the key: react-hotkeys-hook applies its
 * own `preventDefault` *before* it evaluates `enabled` or calls the handler, so
 * by the time either can look, the flag is true for every such key and says
 * nothing. The query runs mid-dispatch, while the layer React is about to
 * unmount is still mounted.
 *
 * Floating layers are matched by Popper's wrapper rather than by role, because
 * the roles are all different (`menu`, `listbox`, none at all for a popover)
 * while the wrapper is common to every one of them — and, unlike a bare
 * `[data-state="open"]`, it does not also match an expanded collapsible or
 * accordion, which own no keyboard.
 */
export const isFloatingLayerOpen = (): boolean =>
  document.querySelector(
    '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [data-radix-popper-content-wrapper]',
  ) !== null;
